import { SuccessStoryType } from "@/shared/types/common.types";
import Image from "next/image";

const TestimonyCarouselCard = ({
  successStory,
  isPricingPage = false,
}: {
  successStory: SuccessStoryType;
  isPricingPage?: boolean;
}) => {
  return (
    <div className={`group/card pointer-events-none relative flex flex-1 items-center text-grey-4 ${
      isPricingPage 
        ? 'flex-col gap-6 sm:flex-row sm:gap-8' 
        : 'flex-col-reverse gap-4 sm:flex-row sm:gap-8'
    }`}>
      <div className="flex flex-row items-center justify-center gap-2 self-start text-left sm:flex-col sm:gap-3 sm:text-center">
        <div className={`relative overflow-hidden rounded-full bg-grey-4 ${
          isPricingPage 
            ? 'h-8 w-8 sm:h-32 sm:w-32 mx-2 sm:mx-4' 
            : 'h-6 w-6 sm:h-28 sm:w-28'
        }`}>
          <Image
            src={successStory.avatar}
            alt={`${successStory.name}'s image`}
            fill
          />
        </div>
        <div className="flex flex-col">
          <div className="text-title-16">{successStory.name}</div>
          <div className="text-body-12">
            {successStory.designation} | {successStory.company}
          </div>
        </div>
      </div>
      <div className="text-body-16 sm:text-body-24">
        {successStory.description}
      </div>
      {/* <BgQuotes className="-z-1 pointer-events-none absolute bottom-0 right-0 sm:hidden" /> */}
    </div>
  );
};

export default TestimonyCarouselCard;
